module.exports = __webpack_public_path__ + "img/88@2x.695b7887.png";